import React from 'react';

import cx from 'classnames';
// import isEqual from 'is-equal';
// import TinyMCE from 'react-tinymce';
import CollectionWidgetManager from 'src/services/collections.widget.service'
// import contentStyle from './DescriptionContentEditor.module.scss';

import { Row, Col, Image } from 'react-bootstrap';
import DefaultLogo from '../../../../../images/default_user_profile_background.png'
import { ToolBar, ToolBarGroup } from '../../../../../components/ToolBar/ToolBar';
import { ToolBarButtonItem } from '../../../../../components/ToolBar/ToolBarButtonItem';
import BannerImageEditor from "../../../../../components/BannerImageEditor";
import Banner from "../../../../../components/Banner";
import ImageTools from '../../../../../services/ImageTools';

import DefaultBackground from '../../../../../images/default_account_banner.jpg';
import { DEFAULT_FONTS as fonts } from 'src/constants/fonts';
import styles from '../../FliteviewSettingsView.module.scss';
import { localizedStrings } from '../../../../../../localization';
import DOMPurify from "dompurify";
import _ from 'lodash';
import RichTextEditor from 'src/components/richTextEditor';

class LibrarySettings extends React.Component {
  constructor(props) {
    super(props);
    this.widgetManager = new CollectionWidgetManager();

    this.state = {
      editBanner: false
    }

    this.handleEditBannerClicked = this.handleEditBannerClicked.bind(this);
    this.onBackgroundImageChanged = this.onBackgroundImageChanged.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);

    this._handleCompanyLogoUpload = this._handleCompanyLogoUpload.bind(this);
    this.handleShareTextChange = this.handleShareTextChange.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedViewerSettings = this.localizedSettings.account.viewer_settings;
  }

  renderLogo(logo) {
    return logo?.full || (typeof logo === 'string' ? logo : DefaultLogo);
  }

  handleMessageChange(value){
    const settings = this.props.value.librarySettings;
    var request = {
      ...settings,
      message: value
    };

    this.props.onChange(request);
  }

  getBackgroundImage(settings){
    if(settings.banner && settings.banner.background){
      var background = settings.banner.background;
      if(typeof background === 'string'){
        return background;
      }else if(background.full){
        return background.full;
      }
    }

    return DefaultBackground;
  }

  getBackgroundType(banner){
    if(banner == null){
      return 'image';
    }

    if(banner.mediaType){
      return banner.mediaType;
    }

    if(banner.background){
      return banner.background.type;
    }

    return "image";
  }


  handleEditBannerClicked(){
    this.setState({
      editBanner: true
    })
  }

  onBackgroundImageChanged(data){
    const settings = this.props.value.librarySettings || {banner: {}};
    var request = {
      ...settings,
      banner: {
        ...settings.banner,
        ...data
      }
    };

    this.props.onChange(request);
    
    this.setState({
      editBanner: false
    });
  }

  _handleCompanyLogoUpload(e) {
    ImageTools.resize(e.target.files[0], {
      width: 320, // maximum width
      height: 240 // maximum height
    }, (blob, didItResize) => {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.props.onLogoChange(e.target.result);
      };

      reader.readAsDataURL(blob);
    });
  }

  handleShareTextChange(value){
    const settings = this.props.value.librarySettings;
    var request = {
      ...settings,
      shareText: value
    };

    this.props.onChange(request);
  }

  render() {
    const settings = this.props.value.librarySettings || {};
    const companyLogo = this.renderLogo(this.props.value.logo);
    const message = _.get(settings, 'message') || "<p></p>";

    const backgroundImage = this.getBackgroundImage(settings);
    const mediaType = this.getBackgroundType(settings.banner);

    return (
      <div className={styles.librarySettings}>
        <div className={styles.title}>{this.props.title}</div>
        <div className={styles.description}>{this.props.description}</div>
        <div className={styles.wrapper}>
          <Banner value={settings.banner} default={DefaultBackground} />

          <Row>
            <Col md={10} sm={12}>
              <div className={styles.logoEditor}>
                <div className={styles.logo}>
                  <Image src={companyLogo} />
                </div>
                <div className={styles.upload}>
                  <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.localizedViewerSettings.library_settings.change_logo) }}></span>
                  <input type="file" className="file-input-hidden" accept="image/*"
                    onChange={this._handleCompanyLogoUpload}></input>
                </div>
                <div className={styles.shareText}>
                  <input type="text" maxLength="20" 
                    value={settings.shareText}
                    onChange={(e) => this.handleShareTextChange(e.target.value)}
                  >
                  </input>
                  <i className={cx(styles.shareIcon, "paperflite-share")} />               
                </div>
              </div>
              <div className={styles.description}>
                <MessageEditor account={this.props.account} value={message} onChange={this.handleMessageChange} />
              </div>
            </Col>
          </Row>
        </div>
        <ToolBar className={styles.toolbar}>
          <ToolBarGroup>
            <ToolBarButtonItem 
              className={cx(styles.action)} 
              width="auto" 
              height="auto" 
              disabled={this.props.updating} 
              onClick={this.handleEditBannerClicked}>
              <span className="fa fa-file-image-o" />{this.localizedViewerSettings.library_settings.edit_background}
            </ToolBarButtonItem>
          </ToolBarGroup>
        </ToolBar>

        <BannerImageEditor 
          entity='collection'
          show={this.state.editBanner}
          onChange={this.onBackgroundImageChanged} 
          onCancel={() => {
            this.setState({
              editBanner: false
            });
          }} 
          user={this.props.user}
          value={{
            ...settings.banner,
            mediaType: mediaType,
            background: backgroundImage
          }}
          source="Collection"
        />

      </div>
    )
  }
}

class MessageEditor extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      content: this.props.value
    }

    this.widgetManager = new CollectionWidgetManager();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    if(this.props.onChange){
      this.props.onChange(e.target.getContent());
    }
  }

  getFonts(){
    var fontArray = [...fonts]; 
    var customFonts = _.get(this.props, 'account.theme.fonts', []);
    
    if(customFonts && customFonts.length > 0){ 
      fontArray  = [...customFonts, ...fontArray];
    }

    return fontArray.map(font => {
      return `${font.name}=${font.fontFamily}`
    }).join(';');
  }

  render() {
    let customfontStyle = _.get(this.props, 'account.theme.customStyleSheet', '');
    
    return (
      <div className={styles.editor}>
      <RichTextEditor
          fontSizeFormats='5pt 5.5pt 6.5pt 7.5pt 8pt 9pt 10pt 10.5pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt'
          content={this.state.content}
          onChange={this.handleChange}
          className={styles.edit}
          toolbar='undo redo | bold italic | alignleft aligncenter alignright | fontselect | fontsizeselect | forecolor backcolor | code'
          customFontStyle={customfontStyle}
          fonts={this.getFonts()}
          plugins='code, autoresize, noneditable, paste, link, autolink, textcolor, lists'     
      />
      </div>  

    );
  }
}

export default LibrarySettings;